import type { ExternalIdChangeData } from '@festina/legalentity-general-types/legalentity'
import { CompaniesService } from '@festina/legalentity-general-types/legalentity/services/CompaniesService'
import { useFestinaMutation } from '@festina-life/authentication'

import type { CompanyActionProps } from '../types'

const method = CompaniesService.legalEntitiesCompanyServicePutUpdateExternalId

type TriggerProps = ExternalIdChangeData

export const useCreateExternalIdChangeDataCompany = ({
  tenantId,
  companyId,
}: CompanyActionProps) =>
  useFestinaMutation({
    component: 'legalEntity',
    roles:
      CompaniesService.legalEntitiesCompanyServicePutUpdateExternalId_roles,
    isScenario: false,
    mutateFunction: async (requestBody: TriggerProps) => {
      await method({
        xTenantId: tenantId,
        companyId,
        requestBody: { ...requestBody, _type: 'ExternalIdChangeData' },
      })
    },
  })
